import React from "react";
import "./ErrorMessage.css";

function ErrorMessage({ message = "Something went wrong.", onRetry }) {
  return (
    <div className="tt-error-wrap" role="alert">
      <p className="tt-error-text">{message}</p>
      {onRetry && (
        <button type="button" className="tt-error-retry" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export default ErrorMessage;
